"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _fishermanOneFish = _interopRequireDefault(require("./fisherman-one-fish.png"));

var _fishermanTwoFish = _interopRequireDefault(require("./fisherman-two-fish.png"));

var _fishermanText = _interopRequireDefault(require("./fisherman-text.png")); // logo assets
// static vars


var sizeMap = {
  tiny: 1,
  small: 2,
  medium: 3,
  large: 4,
  huge: 5,
  massive: 6
};
var assetMap = {
  oneFishLogo: _fishermanOneFish["default"],
  twoFishLogo: _fishermanTwoFish["default"],
  textLogo: _fishermanText["default"],
  poweredBy: _fishermanText["default"]
};
var baseSize = 20;

var FishermanIcon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(FishermanIcon, _React$PureComponent);

  function FishermanIcon() {
    (0, _classCallCheck2["default"])(this, FishermanIcon);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FishermanIcon).apply(this, arguments));
  }

  (0, _createClass2["default"])(FishermanIcon, [{
    key: "getContainer",
    value: function getContainer(asset) {
      var _this$props = this.props,
          as = _this$props.as,
          size = _this$props.size;

      if (as === 'link') {
        return _react["default"].createElement("a", {
          href: "https://fishrmn.com"
        }, asset);
      }

      if (as === 'button') {
        return _react["default"].createElement(_semanticUiReact.Button, {
          size: size,
          secondary: true
        }, asset);
      }

      if (as === 'image') return asset;
      return asset;
    }
  }, {
    key: "getWrappedAsset",
    value: function getWrappedAsset() {
      var assetType = this.props.assetType;
      var assetImage = assetMap[assetType];

      if (assetType === 'poweredBy') {
        return _react["default"].createElement(_semanticUiReact.List, {
          horizontal: true
        }, _react["default"].createElement(_semanticUiReact.List.Item, null, _react["default"].createElement("div", {
          style: {
            color: 'white'
          }
        }, "Powered By")), _react["default"].createElement(_semanticUiReact.List.Item, null, _react["default"].createElement(_semanticUiReact.Image, {
          src: assetMap.poweredBy,
          height: "25",
          style: {
            marginTop: '-5px',
            marginLeft: '-8px'
          }
        })));
      }

      return _react["default"].createElement(_semanticUiReact.Image, {
        src: assetImage,
        height: this.calculateSize()
      });
    }
  }, {
    key: "calculateSize",
    value: function calculateSize() {
      var size = this.props.size;
      return baseSize * sizeMap[size];
    }
  }, {
    key: "render",
    value: function render() {
      var assetWrapped = this.getWrappedAsset();
      return this.getContainer(assetWrapped);
    }
  }]);
  return FishermanIcon;
}(_react["default"].PureComponent);

exports["default"] = FishermanIcon;
FishermanIcon.propTypes = {
  assetType: _propTypes["default"].oneOf(['oneFishLogo', 'twoFishLogo', 'textLogo', 'poweredBy']),
  as: _propTypes["default"].oneOf(['link', 'button', 'image']),
  size: _propTypes["default"].oneOf(['tiny', 'small', 'medium', 'large', 'huge', 'massive'])
};
FishermanIcon.defaultProps = {
  assetType: 'twoFishLogo',
  as: 'image',
  size: 'small'
};